<template>
  <div v-if="isVisible" class="custom-modal-overlay">
    <div v-if="currentPage === 'placeLien'" class="custom-modal-container-lien">
      <button @click="closeModal" class="close-button">
        <img src="@/assets/img/close.svg" alt="" />
      </button>
      <div class="custom-modal-header">
        <h3
          style="
            font-size: 18px;
            font-weight: 700;
            color: #23242f;
            margin-bottom: 20px;
          "
        >
          {{ isEditLien ? "VIEW LIEN" : "PLACE LIEN" }}
        </h3>
      </div>

      <div class="custom-modal-body">
        <form action="submit">
          <fg-input
            type="number"
            label="Amount"
            placeholder="Amount"
            v-model="agentLienDetails.amount"
            aria-required="true"
          ></fg-input>

          <fg-input
            type="date"
            label="Expiry Date"
            placeholder="Expiry Date"
            v-model="agent.expiresAt"
            aria-required="true"
            :min="getTomorrowDate()"
            :max="getMaxDate()"
          >
          </fg-input>

          <div class="form-group">
            <label for="reason">Comment</label>
            <textarea
              class="form-control"
              id="comment"
              rows="5"
              cols="5"
              v-model="agentLienDetails.reason"
              aria-required="true"
            ></textarea>
          </div>

          <button
            v-if="isEditLien === false"
            type="button"
            class="btn btn-info w-100"
            style="
              margin-top: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
            @click="createLIEN"
          >
            <span v-if="loading" class="spin"></span>
            Activate lien
          </button>

          <div
            style="
              display: flex;
              align-items: center;
              gap: 8px;
              margin-top: 30px;
            "
            v-if="isEditLien === true"
          >
            <button
              type="button"
              class="btn"
              style="
                background: #e02b00;
                color: #fff;
                border: none;
                width: 100%;
              "
              @click="currentPage = 'removeLien'"
            >
              <span v-if="loadingRemove" class="spin"></span>
              Remove lien
            </button>
            <button
              type="button"
              class="btn btn-info"
              style="
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 4px;
              "
              @click="updateLIEN"
            >
              <span v-if="loadingUpdate" class="spin"></span>
              Update lien
            </button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="currentPage === 'success'" class="custom-modal-container-lien">
      <img src="@/assets/img/success.png" alt="image" class="icon_image" />
      <div class="custom-modal-header">
        <h3
          style="
            font-size: 24px;
            font-weight: 700;
            color: #373737;
            margin-bottom: 20px;
            text-transform: capitalize;
          "
        >
          LIEN {{ this.successText }}
        </h3>
      </div>

      <div class="custom-modal-body">
        <p>LIEN has been {{ this.successText }} successfully</p>

        <button
          type="submit"
          class="btn btn-info w-100"
          style="margin-top: 30px"
          @click="closeModal"
        >
          Done
        </button>
      </div>
    </div>

    <div
      v-if="currentPage === 'removeLien'"
      class="custom-modal-container-lien"
    >
      <img src="@/assets/img/remove.png" alt="image" class="icon_image" />
      <div class="custom-modal-header">
        <h3
          style="
            font-size: 24px;
            font-weight: 700;
            color: #373737;
            margin-bottom: 20px;
          "
        >
          REMOVE LIEN
        </h3>
      </div>

      <div class="custom-modal-body">
        <p>Are you sure you want to remove this LIEN?</p>

        <div
          style="display: flex; align-items: center; gap: 8px; margin-top: 30px"
        >
          <button
            type="submit"
            class="btn"
            style="background: #e02b00; color: #fff; border: none; width: 100%"
            @click="closeModal"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-info"
            style="
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            @click="deleteLIEN"
          >
            <span v-if="loading" class="spin"></span>
            Proceed
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../store/axios";
import { max } from "moment";
export default {
  props: {
    isVisible: Boolean,
    agentId: {
      type: String,
      required: true,
    },
    isEditLien: {
      type: Boolean,
      default: null,
    },
    agentLienDetails: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      loading: false,
      loadingRemove: false,
      loadingUpdate: false,
      currentPage: "placeLien",
      successText: "",
      agent: {
        ...this.agentLienDetails,
        expiresAt: this.agentLienDetails.expiresAt
          ? new Date(this.agentLienDetails.expiresAt)
              .toISOString()
              .split("T")[0]
          : "",
        expiresAt: "",
      },
    };
  },

  methods: {
    getTomorrowDate() {
      const today = new Date();
      today.setDate(today.getDate() + 1);
      return today.toISOString().split("T")[0];
    },
    getMaxDate() {
      const nextYear = new Date();
      nextYear.setFullYear(nextYear.getFullYear() + 1);
      return nextYear.toISOString().split("T")[0];
    },
    closeModal() {
      this.$emit("close");
      this.currentPage = "placeLien";
      this.successText = "";
      window.location.reload();
    },

    async createLIEN() {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/add-lien`,
          {
            agentId: this.agentId,
            amount: this.agentLienDetails.amount,
            expiresAt: new Date(this.agent.expiresAt).toISOString(),
            reason: this.agentLienDetails.reason,
            type: "LIEN_AMOUNT",
          },
        );
        this.loading = false;
        this.successText = "activated";
        this.currentPage = "success";
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$toast.error(err.res.data.message);
      }
    },

    async updateLIEN() {
      event.preventDefault();
      this.loadingUpdate = true;

      try {
        const res = await axios.put(
          `${process.env.VUE_APP_API_URL}/update-lien/${this.agentLienDetails._id}`,
          {
            agentId: this.agentId,
            amount: this.agentLienDetails.amount,
            expiresAt: new Date(this.agent.expiresAt).toISOString(),
            reason: this.agentLienDetails.reason,
            type: "LIEN_AMOUNT",
          },
        );
        this.loadingUpdate = false;
        this.successText = "updated";
        this.currentPage = "success";
      } catch (err) {
        console.log(err);
        this.loadingUpdate = false;
        this.$toast.error(err.res.data.message);
      }
    },

    async deleteLIEN() {
      this.loadingRemove = true;

      try {
        const res = await axios.delete(
          `${process.env.VUE_APP_API_URL}/delete-lien/${this.agentLienDetails._id}`,
          {
            data: { agentId: this.agentId },
          },
        );

        this.loadingRemove = false;
        this.currentPage = "success";
        this.successText = "removed";
      } catch (err) {
        console.log(err);
        this.loadingRemove = false;
        const message =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : "Something went wrong. Please try again.";

        this.$toast.error(message);
        // this.closeModal();
      }
    },
  },

  // watch: {
  //   agentLienDetails: {
  //     handler(newVal) {
  //       this.agent = {
  //         ...newVal,
  //         expiresAt: newVal.expiresAt
  //           ? new Date(newVal.expiresAt).toISOString().split("T")[0]
  //           : "",
  //       };
  //     },
  //     deep: true,
  //   },
  // },

  watch: {
    agentLienDetails: {
      handler(newVal) {
        if (newVal.expiresAt) {
          this.agent.expiresAt = new Date(newVal.expiresAt)
            .toISOString()
            .split("T")[0];
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.custom-modal-container-lien {
  background-color: white;
  width: 100%;
  border-radius: 8px;
  max-width: 465px;
  overflow: hidden;
  overflow-y: auto;
  max-height: 100vh;
  padding: 40px 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.custom-modal-body {
  width: 100%;
}

.custom-modal-body p {
  color: #9497b8;
  font-size: 16px;
  text-align: center;
}

.close-button {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
}
</style>
